import React, { useEffect, useState } from 'react'
import { Button, Form, InputGroup, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';

import plusIcon from '../../../assets/icons/plus-button.png';
import minusIcon from '../../../assets/icons/minus.png';

const NebulaCertificates = ({ parentState, onChangeFormControl, onSendCredentialsAndGetAuthenticators, onSendAuthenticator, onSendChallenge, onUnauthorizeNebulaCertificate, authenticators, children }) => {
    const { t } = useTranslation();
    const certsNotAvailable = <p>{t('certificates.certificate-not-available')}</p>;
    const {
        certificatesOrdered: { Nebula },
        nebulaStep1,
        nebulaStep2,
        NBauthenticator,
        nebulaStep3
    } = parentState;

    const [showAuthorizeModal, setShowAuthorizeModal] = useState(false);

    const nebulaColumns = [
        {
            dataField: 'certalias',
            text: t('certificates.certificate'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'headerClass1',
            style: { verticalAlign: 'middle' }
        },
        {
            dataField: 'ExpirationDate',
            text: t('certificates.certificate-date'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'headerClass2',
            style: { verticalAlign: 'middle' }
        }
    ];

    const [NBuser, setNBuser] = useState('');
    const [NBpassword, setNBpassword] = useState('');
    const [NBClient, setNBClient] = useState('');
    const [NBChallenge, setNBChallenge] = useState('');
    const [selectedAuthenticator, setSelectedAuthenticator] = useState(NBauthenticator || '');

    useEffect(() => {
      setSelectedAuthenticator(NBauthenticator || '');
    }, [NBauthenticator]);

    const handleAuthenticatorSelection = (authenticator) => {
      setSelectedAuthenticator(authenticator);
      onChangeFormControl("NBauthenticator", authenticator);
    };

    return (
      <div className="table-container">
        <div className='table-container-header'>
          {Nebula.length > 0 && (
            <button
              className="new-create-button"
              onClick={onUnauthorizeNebulaCertificate}
            >
              <img src={minusIcon} alt="minus icon" />
              <span>{t("general.unauthorize")}</span>
            </button>
          )}
          {nebulaStep1 && Nebula.length === 0 && (
            <button
              className="new-create-button"
              onClick={() => setShowAuthorizeModal(true)}
            >
              <img src={plusIcon} alt="plus icon" />
              <span>{t("general.authorize")}</span>
            </button>
          )}
          {Nebula.length > 0 && children}
        </div>
        {Nebula.length === 0 && nebulaStep1 && <div>{certsNotAvailable}</div>}

        <Modal
          show={showAuthorizeModal}
          onHide={() => setShowAuthorizeModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("general.authorize")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="nebula-user">
                  {t("general.user")}
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                required
                type="text"
                aria-label="Default"
                aria-describedby="nebula-user"
                value={NBuser}
                onChange={(e) => setNBuser(e.target.value)}
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="nebula-password">
                  {t("general.password")}
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                required
                type="password"
                aria-label="Default"
                aria-describedby="nebula-password"
                value={NBpassword}
                onChange={(e) => setNBpassword(e.target.value)}
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="nebula-clientId">
                  {t("general.clientId")}
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                required
                type="text"
                aria-label="Default"
                aria-describedby="nebula-clientId"
                value={NBClient}
                onChange={(e) => setNBClient(e.target.value)}
              />
            </InputGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={!NBuser || !NBpassword || !NBClient}
              type="button"
              className="btn btn-primary signature-image"
              onClick={() =>{
                setShowAuthorizeModal(false);
                onSendCredentialsAndGetAuthenticators({
                  NBuser,
                  NBpassword,
                  NBClient,
                })}
              }
            >
              {t("general.authorize")}
            </Button>
          </Modal.Footer>
        </Modal>
        {Nebula.length === 0 && nebulaStep2 && (
          <Modal
            show={nebulaStep2}
            onHide={() => onChangeFormControl("nebulaStep2", false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{t("general.authorize")}</Modal.Title>
            </Modal.Header>
            <Form>
              <Modal.Body>
                <Form.Group controlId="exampleForm.ControlSelect1">
                  <Form.Label>{t("documents.nebula-authenticator")}</Form.Label>
                  <Form.Control
                    as="select"
                    value={selectedAuthenticator}
                    onChange={(e) =>
                      handleAuthenticatorSelection(e.target.value)
                    }
                  >
                    <option value="">
                      {t("documents.select-one-authenticator")}
                    </option>
                    {authenticators.map((auth, i) => {
                      return (
                        <option value={auth} key={i}>
                          {auth}
                        </option>
                      );
                    })}
                  </Form.Control>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  disabled={!selectedAuthenticator}
                  type="button"
                  className="btn btn-primary signature-image"
                  onClick={() => onSendAuthenticator(selectedAuthenticator)}
                >
                  {t("general.authorize")}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        )}
        {Nebula.length === 0 && nebulaStep3 && (
          <Modal
            show={nebulaStep3}
            onHide={() => onChangeFormControl("nebulaStep3", false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{t("general.authorize")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {t("documents.nebula-otp")} {NBauthenticator}
              <InputGroup className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="nebula-user">
                    {t("general.otp")}
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  required
                  type="text"
                  aria-label="Default"
                  aria-describedby="nebula-challenge"
                  value={NBChallenge}
                  onChange={(e) => setNBChallenge(e.target.value)}
                />
              </InputGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button
                disabled={!NBChallenge}
                type="button"
                id="authorizeNB"
                className="btn btn-primary signature-image"
                onClick={() => onSendChallenge({ NBChallenge })}
              >
                {t("general.confirm")}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {Nebula.length > 0 && (
          <div>
            <ToolkitProvider
              keyField="GUID"
              data={Nebula}
              columns={nebulaColumns}
            >
              {(props) => (
                <div>
                  <BootstrapTable striped {...props.baseProps} />
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </div>
    );
}

export default NebulaCertificates
